import { GoldenSourceHelper } from "../../../app/Switch_Core_React_Standards";
import { dbPayload } from "../../../auth/registered/SEC_00_DB_Payload";

// HR & Workforce — nrgCore HrSyncController (api/v1/sustina/hr-sync/*, HR_SYNC.usp_*).
// The signed-in user comes from the session on the server; who may do what is
// decided by the HR_SYNC procs.
const BASE = "/api/v1/sustina/hr-sync";
const siteKey = process.env.REACT_APP_SITE_KEY;

const call = async (op, body) => {
  const raw = await dbPayload(`${BASE}/${op}`, "POST", siteKey, GoldenSourceHelper.prepareForApi(body || {}));
  const res = GoldenSourceHelper.normalize(raw);
  if (!res || !res.success) throw new Error(res?.message || `HR ${op} failed.`);
  return res.data;
};
const list = async (op, body) => (await call(op, body)) || [];

// connector account (global admin)
export const fetchProviderStatus = () => list("admin/provider-status", {});
export const saveProvider = ({ apiBaseUrl, apiKey, isEnabled }) =>
  list("admin/provider-set", { ProviderCode: "KOMBO", ApiBaseUrl: apiBaseUrl || null, ApiKey: apiKey || null, IsEnabled: !!isEnabled });

// company connection
export const fetchStatus = (companyId) => call("status", { CorporateEntityId: Number(companyId) });
export const createConnectLink = (companyId, organisationName, language) =>
  call("connect/link", { CorporateEntityId: Number(companyId), OrganisationName: organisationName, Language: language || "en" });
export const activateConnection = (companyId, token) =>
  list("connect/activate", { CorporateEntityId: Number(companyId), Token: token });
export const syncNow = (connectionId, from, to) => call("sync", { ConnectionId: connectionId, PeriodFrom: from, PeriodTo: to });
export const disconnect = (connectionId) => list("disconnect", { ConnectionId: connectionId });

// figures
export const fetchMetrics = (companyId, from, to) =>
  list("metrics", { CorporateEntityId: Number(companyId), PeriodFrom: from, PeriodTo: to });
export const saveManualMetrics = (companyId, from, to, metrics) =>
  list("manual/set", { CorporateEntityId: Number(companyId), PeriodFrom: from, PeriodTo: to, MetricsJson: JSON.stringify(metrics) });

// own HR codes
export const fetchCodes = (companyId) => list("codes/list", { CorporateEntityId: Number(companyId) });
export const importCodes = (companyId, rows) =>
  list("codes/import", { CorporateEntityId: Number(companyId), JsonRows: JSON.stringify(rows) });
export const mapCode = (hrCodeId, targetMetricCode) => list("codes/map", { HrCodeId: hrCodeId, TargetMetricCode: targetMetricCode || null });
export const removeCode = (hrCodeId) => list("codes/remove", { HrCodeId: hrCodeId });

/** Kombo's connect widget, loaded on demand (no build-time dependency). */
const KOMBO_SCRIPT = "https://unpkg.com/@kombo-api/connect@1/dist/index.js";
export const openConnectWidget = (link) =>
  new Promise((resolve, reject) => {
    const run = () => {
      const api = window.KomboConnect;
      if (!api || typeof api.showKomboConnect !== "function") return reject(new Error("The connect window could not be loaded."));
      Promise.resolve(api.showKomboConnect(link)).then(resolve, reject);
    };
    if (window.KomboConnect) return run();
    const s = document.createElement("script");
    s.src = KOMBO_SCRIPT;
    s.async = true;
    s.onload = run;
    s.onerror = () => reject(new Error("The connect window could not be loaded."));
    document.head.appendChild(s);
    return undefined;
  });
